import React, { useState } from 'react';
import { Container, Card, Form, Row, Col, Alert } from 'react-bootstrap';
import DateTimePicker from './DateTimePicker';

const DateTimePickerDemo = () => {
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [use24Hour, setUse24Hour] = useState(false);
  const [isASAP, setIsASAP] = useState(false);

  const handleDateTimeChange = (date, asapStatus) => {
    setSelectedDateTime(date);
    setIsASAP(asapStatus);
    console.log('Selected DateTime:', date, 'ASAP:', asapStatus);
  };

  const handleFormatChange = (e) => {
    const newUse24Hour = e.target.checked;
    setUse24Hour(newUse24Hour);
  };

  return (
    <Container className="py-4">
      <Card>
        <Card.Header>
          <h4>DateTime Picker Demo</h4>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row className="mb-3">
              <Col xs={12} sm={6}>
                <Form.Check
                  type="switch"
                  id="24hour-switch"
                  label="Use 24-Hour Format"
                  checked={use24Hour}
                  onChange={handleFormatChange}
                />
              </Col>
            </Row>

            <DateTimePicker
              value={selectedDateTime}
              onChange={handleDateTimeChange}
              label="Select Date & Time"
              className="mb-3"
              use24Hour={use24Hour}
              show24HourToggle={true}
            />
            
            {/* ASAP Status Alert */}
            {isASAP && (
              <Alert variant="danger" className="mb-3">
                <Alert.Heading>🚨 URGENT REQUEST</Alert.Heading>
                <p>
                  This request has been marked as ASAP (As Soon As Possible). 
                  The service will be prioritized for immediate attention.
                </p>
              </Alert>
            )}
            
            <Form.Group className="mb-3">
              <Form.Label>Selected DateTime:</Form.Label>
              <Form.Control
                type="text"
                value={selectedDateTime.toLocaleString()}
                readOnly
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>ISO String:</Form.Label>
              <Form.Control
                type="text"
                value={selectedDateTime.toISOString()}
                readOnly
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Format Used:</Form.Label>
              <Form.Control
                type="text"
                value={use24Hour ? "24-Hour Format" : "12-Hour Format"}
                readOnly
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>ASAP Status:</Form.Label>
              <Form.Control
                type="text"
                value={isASAP ? "🚨 URGENT - ASAP Enabled" : "Normal Priority"}
                readOnly
                className={isASAP ? "text-danger fw-bold" : ""}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Time Components:</Form.Label>
              <Form.Control
                type="text"
                value={`Hour: ${selectedDateTime.getHours()}, Minute: ${selectedDateTime.getMinutes()}, AM/PM: ${selectedDateTime.getHours() < 12 ? 'AM' : 'PM'}`}
                readOnly
              />
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default DateTimePickerDemo; 